const styles = (theme) => ({
  container:{
    color: theme.iconColor
  },
  divider: {
    borderBottom: `1px solid ${theme.gridIconBorderColor}`,
    width: '100%',
    opacity: '0.7',
    height: '0px',
    marginTop: 8
  },
  title: {
    fontSize: theme.textFontSize,
    fontWeight: 'bold',
    marginTop: 12,
    textTransform: 'uppercase'
  },
  subHeading: {
    color: theme.dispatchPanelHeaderColor,
    marginBottom: 2
  },
  equipmentTypeContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  root: {
    padding: '0 8 2 14',
    color: theme.gridIconBorderColor,
    '&$checked': {
      color: theme.HeaderSelectedText
    }
  },
  checked: {
    color: theme.HeaderSelectedText
  },
  checkBoxLabel: {
    color: theme.gridTextColor,
    margin: '4 0 4 0'
  },
  checkBoxMargin: {
    display: 'flex',
    marginRight: 2
  },
  checkboxContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: '4 0'
  },
  checkboxSelect: {
    display: 'flex'
  },
  equipmentLabel: {
    fontSize: theme.textFontSize,
    color: theme.dispatchPanelHeaderColor,
  },
});

export default styles;
